var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[_c('div',{staticClass:"trigger-section"},[_c('NewActionBlock',{class:{ 'has-blocks': _vm.blocks.length },attrs:{"index":-1},on:{"selected":_vm.addBlock}})],1),_c('div',{staticClass:"list-blocks"},[_c('ListBlock',{attrs:{"blocks":_vm.blocks,"level":"1","automation":_vm.automation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }